import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";

const LogisticsInfo = () => {
  return (
    <Box
      sx={{
        width: "100%",
        py: { xs: 3, md: 8 },
        px: { xs: 3, md: 14 },
        bgcolor: "#f6f8fb",
      }}
    >
      <Grid container spacing={5} alignItems="center">
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Box
              component="img"
              src={require("../../static/media/home/house.webp")}
              alt="Logística Hydroluz"
              sx={{
                width: "100%",
                maxWidth: 450,
                borderRadius: 4,
                boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
              }}
            />
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                color: "#003366",
                fontSize: { xs: "1.6rem", md: "2.2rem" },
                mb: 2,
              }}
            >
              Compras seguras y entregas confiables
            </Typography>

            <Typography
              sx={{
                color: "#555",
                fontSize: { xs: "0.95rem", md: "1rem" },
                lineHeight: 1.7,
                mb: 3,
              }}
            >
              Explora nuestro catálogo completo y encuentra los productos que
              necesitas de forma rápida y sencilla. Nuestra tienda en línea
              está diseñada para que puedas revisar todas nuestras categorías y
              tomar decisiones con total tranquilidad.
            </Typography>

            <Typography
              sx={{
                color: "#555",
                fontSize: { xs: "0.95rem", md: "1rem" },
                lineHeight: 1.7,
                mb: 4,
              }}
            >
              Nosotros nos encargamos de toda la logística para asegurar
              entregas seguras y confiables. Gestionamos cada pedido con
              responsabilidad para que recibas tus productos en perfectas
              condiciones y sin complicaciones.
            </Typography>

            <Button
              variant="contained"
              href="/categorias"
              sx={{
                bgcolor: "#003366",
                px: 4,
                py: 1.2,
                borderRadius: 2,
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "#00264d",
                },
              }}
            >
              Ver catálogo
            </Button>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LogisticsInfo;